"use client";
import { Upload } from "antd";
import Button from "./Button";
import { UploadFieldProps } from "./types";

const UploadField: React.FC<UploadFieldProps> = ({
  label,
  value,
  onChange,
  onRemove,
  accept,
  maxSize,
  error,
  errorMessage,
  disabled,
  ...rest
}) => {
  const handleBeforeUpload = (file: File) => {
    // Always allow file selection, let Formik handle validation
    onChange?.(file);
    return false; // prevent auto upload
  };

  return (
    <div className="flex flex-col gap-2 w-full">
      {label && <label className="text-input-label block mb-2">{label}</label>}
      <div className="w-full">
        <Upload
          beforeUpload={handleBeforeUpload}
          maxCount={1}
          showUploadList={value ? true : false}
          fileList={value ? [{ name: value.name, uid: "1" }] : []}
          accept={accept}
          customRequest={() => {}}
          onRemove={onRemove}
          disabled={disabled}
          style={{ width: "100%" }}
          {...rest}
        >
          <Button type="default" disabled={disabled} className="w-full">
            Select File
          </Button>
        </Upload>
      </div>
      {error && errorMessage && (
        <div className="text-[10px] text-[#FF1F1F] mt-1">{errorMessage}</div>
      )}
    </div>
  );
};

export default UploadField;
